export const datasetSupported = Boolean(window.DOMStringMap);
